'use client';

import { createContext, Dispatch, SetStateAction } from 'react';
import { Search_RequestBody } from '@opensearch-project/opensearch/api';
import {
  Hit,
  ResponseBody,
} from '@opensearch-project/opensearch/api/_types/_core.search';
import { Aggregate } from '@opensearch-project/opensearch/api/_types/_common.aggregations';
import {
  QueryContainer,
  RangeQuery,
} from '@opensearch-project/opensearch/api/_types/_common.query_dsl';
import { QueryObserverResult, RefetchOptions } from '@tanstack/react-query';
import { Sort } from '@opensearch-project/opensearch/api/_types/_common';

interface OpenSearchState {
  searchBody: Search_RequestBody;
  hits: Hit[];
  totalHits: number;
  aggregations: Record<string, Aggregate>;
  queryFiltersByFacets: Record<string, QueryContainer | RangeQuery>;
  updateQueryFiltersByFacets: Dispatch<
    SetStateAction<Record<string, QueryContainer | RangeQuery>>
  >;
  fixedQueryFiltersByFacets: Record<string, QueryContainer | RangeQuery>;
  updateFixedQueryFiltersByFacets: Dispatch<
    SetStateAction<Record<string, QueryContainer | RangeQuery>>
  >;
  isLoading: boolean;
  isFetching: boolean;
  pageSize?: number;
  updatePageSize: Dispatch<SetStateAction<number | undefined>>;
  updateSize: Dispatch<SetStateAction<number | undefined>>;
  from: number;
  updateFrom: Dispatch<SetStateAction<number>>;
  linkPendingPage: number | null;
  setLinkPendingPage: Dispatch<SetStateAction<number | null>>;
  isLinkNavigationPending: boolean;
  searchableAtributes?: string[];
  updateSearchableAttributes: Dispatch<SetStateAction<string[] | undefined>>;
  sortFilter?: Sort;
  updateSortFilter: Dispatch<SetStateAction<Sort | undefined>>;
  status: 'error' | 'success' | 'pending';
  searchFilter: string;
  updateSearchFilter: Dispatch<SetStateAction<string>>;
  refetch: (
    _options?: RefetchOptions,
  ) => Promise<QueryObserverResult<ResponseBody, Error>>;
}

const OpenSearchContext = createContext<OpenSearchState | undefined>(undefined);
OpenSearchContext.displayName = 'OpenSearchContext';

export { OpenSearchContext };
